import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Typography } from "@mui/material";
import useIsUsAccount from "hooks/useIsUsAccount";
import { setGasServed, selectGasServed } from "../slice";
import GeographicAreaPicker from "components/GeographicAreaPicker";
import { useTranslation } from "react-i18next";

const GeographicAreasServedStep = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isUs = useIsUsAccount();

    const addedAreas = useSelector(selectGasServed);

    return (
        <Container maxWidth="md" sx={{ mt: 2 }}>
            <Typography
                variant="body1"
                align="center"
                sx={{ color: "#475569", mb: 4, maxWidth: 580, mx: "auto" }}
            >
                {t("messages.gas_description", {
                    orgRegion: isUs ? "state" : "province",
                    orgCountry: isUs ? "United States" : "Canada",
                })}
            </Typography>

            <GeographicAreaPicker
                addedAreas={addedAreas}
                onChange={(next) => dispatch(setGasServed(next))}
            />
        </Container>
    );
};

export default GeographicAreasServedStep;
